import { colord } from 'colord'

export const getCssRgbValue = (cssVar: string, opacity?: number) => {
  if (typeof document === 'undefined') return ''

  const value = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim()

  return opacity === undefined ? value : colord(value).alpha(opacity).toRgbString()
}
